import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import Calendar from 'react-calendar'
import Tooltip from '@mui/material/Tooltip';
import {toEuropeanDate,shortMonthName,toDashDate, calculateFinalDate,getAllMonthsinYear, getAQPassedDays, calculateImportoContrattuale, isAccordoQuadro, calculateBudgetReal,calculateMarkupReal,getLastDateOfMonthBefore,getLastDateOfMonth, getAllMonths, toPrice, convertDate, getBusinessDatesCount, calculateMarkup, getWorkedDaysNumber, materialCostCommessa, laborCostCommessa, calculateSAL } from "helpers/functions"
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";

export class CommesseAndamento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selected: -1,

            selectedYear: new Date().getFullYear(),

            worker: [],
            sal:[],

            workerLoaded:false,
            salLoaded: false,

            graphSelected:"COSTI"
            
        };
        this._isMounted = false;
    }

    componentDidMount = () => {
        this._isMounted = true;
        //&populate=incarichi.commessa_madre
        ajax.ajaxGetStrapi("commessas?populate=*&filters[stato][$ne]=finito&sort[0]=nome&filters[commessa_madre]&populate=fattures&populate=commessa_madre&populate=incarichi.*&populate=incarichi.commessa_madre&populate=incarichi.fattures&populate=gara", this.loadCallback)
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    loadCallback = (response) => {
        if (this._isMounted) {
            this.setState({ data: response.data })
        }
    }

    renderButton = (name, index) => {
        return (
            <Grid container key={"btn-commessa-" + index}>
                <MDButton variant="text" onClick={() => { this.setSelected(index) }} color="info" sx={{textAlign: "left", justifyContent: "left"}}>{name}</MDButton>
            </Grid>
        )
    }

    setSelected = (index) => {
        if (index == this.state.selected) {return}
        this.setState({
            selected: index, worker: [], workerLoaded: false, salLoaded: false, selectedYear: new Date().getFullYear() });

        let filter = "&filters[commessa][id]=" + this.state.data[index].id;
        if (this.state.data[index].incarichi.length > 0) {
            filter = "";
            this.state.data[index].incarichi.map((el, i) => {
                filter += "&filters[commessa][id][$in][" + i + "]=" + el.id;
            })
        }

        ajax.ajaxGetStrapi("operai-commesses?populate=operaio" + filter, this.loadWorker)
        ajax.ajaxGetStrapi("sal-commessas?filters[commessa][id][$eq]=" + this.state.data[index].id, this.loadSal)
    }

    loadSal = (response) => {
        if (!this._isMounted) return;
        if (response && response.data) {
            this.setState({ sal: response.data, salLoaded: true });
        } else {
            console.log("Errore nel caricamento SAL:", response);
            this.setState({ sal: [], salLoaded: true });
        }
    }

    loadWorker = (response) => {
        if (!this._isMounted) return;
        if (response && response.data) {
            this.setState({worker: response.data, workerLoaded: true });
        } else {
            console.log("Errore nel caricamento worker:", response);
            this.setState({worker: [], workerLoaded: true });
        }
    }

    totalDuration = () => {
        let duration = this.state.data[this.state.selected].durata;
        let duration2 = this.state.data[this.state.selected].proroga;

        if (isNaN(parseInt(duration))) {
            duration = 0;
        }
        if (isNaN(parseInt(duration2))) {
            duration2 = 0;
        }

        return parseInt(duration) + parseInt(duration2);
    }


    renderDati = () => {
        let el = this.state.data[this.state.selected]

        let totalDuration = this.totalDuration();
        let workedDays = getWorkedDaysNumber(this.state.worker);

        if (isAccordoQuadro(this.state.data[this.state.selected])) {
            workedDays = getAQPassedDays(this.state.data[this.state.selected]);
        }

        if (workedDays > totalDuration) { workedDays = totalDuration; }

        let materialCost = materialCostCommessa(el)
        let laborCost = laborCostCommessa(this.state.worker, null, null, this.state.data[this.state.selected].id)


        let importoContrattuale = calculateImportoContrattuale(el,false)

        let sal = calculateSAL(this.state.sal) / 100;
        let markupReal = calculateMarkupReal(el, materialCost, laborCost)
        let budgetReal = calculateBudgetReal(el, markupReal)
        let budgetPreventivato = importoContrattuale - (importoContrattuale - (el.costo_ordini + el.costo_manodopera))
        let markupPreventivato = importoContrattuale - (el.costo_ordini + el.costo_manodopera);

        if (el.incarichi.length > 0) {
            importoContrattuale = 0;
            materialCost = 0;

            markupReal = 0;
            budgetReal = 0;
            budgetPreventivato = 0;

            let costoOrdiniPreventivato = 0;
            let costoManodoperaPreventivato = 0;

            el.incarichi.map((incarico, index) => {
                el.fattures = [];
                incarico.fattures.map((fatt) => {
                   el.fattures.push(fatt)
                })
                importoContrattuale += incarico.preventivo;
                materialCost += materialCostCommessa(incarico)
                costoOrdiniPreventivato += incarico.costo_ordini;
                costoManodoperaPreventivato += incarico.costo_manodopera
            })

            markupReal += calculateMarkupReal(el, materialCost, laborCost)
            budgetReal += calculateBudgetReal(el, markupReal)
            budgetPreventivato = importoContrattuale - (importoContrattuale - (costoOrdiniPreventivato + costoManodoperaPreventivato))
            markupPreventivato = importoContrattuale - (costoOrdiniPreventivato + costoManodoperaPreventivato);

        }

        return (
            <Grid ml={2}>
                <MDTypography sx={{display:"block"}} variant={"button"} textTransform={"uppercase"}>{el.nome}</MDTypography>

                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"} mt={2}>Giorni totali <b>{totalDuration}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>{isAccordoQuadro(this.state.data[this.state.selected]) ? "Giorni Passati" : "Giorni lavorati"} <b>{workedDays}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>Giorni mancanti <b>{totalDuration - workedDays}</b></MDTypography>

                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"} mt={2}>costo ordini ad oggi <b>{toPrice(materialCost)}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>costo manodopera ad oggi <b>{toPrice(laborCost)}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>costo totale ad oggi <b>{toPrice(materialCost+laborCost)}</b></MDTypography>

                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"} mt={2}>importo contrattuale <b>{toPrice(importoContrattuale)}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>mark up preventivato <b>{toPrice(markupPreventivato)}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>mark up reale <b>{toPrice(markupReal)}</b></MDTypography>

                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"} mt={2}>budget di commessa preventivato <b>{toPrice(budgetPreventivato)}</b></MDTypography>
                <MDTypography sx={{ display: "block" }} variant={"button"} textTransform={"uppercase"}>budget di commessa reale <b>{toPrice(budgetReal)}</b></MDTypography>

            </Grid>
            )
    }

    changeYear = (n) => {
        let date = this.state.selectedYear
        date += n;
        this.setState({selectedYear:date})
    }


    renderGraphic = () => {
        let data = this.state.data[this.state.selected]

        let icon = "calendar_month";
        if (this.state.graphSelected == "GIORNI") { icon = "calendar_month" }
        if (this.state.graphSelected == "COSTI") { icon = "payments" }
        if (this.state.graphSelected == "MARKUP") { icon = "trending_up" }
        if (this.state.graphSelected == "BUDGET") { icon = "savings" }


        let importoContrattuale = data.preventivo;
        if (data.gara) {
            let amount_subjcet_to_discount_C = data.gara.base_amount - data.gara.security
            let amount_discounted_E = amount_subjcet_to_discount_C * data.gara.discount_percentage / 100
            importoContrattuale = amount_subjcet_to_discount_C - amount_discounted_E + data.gara.security;
        }

    let markupPrev=importoContrattuale - (data.costo_ordini + data.costo_manodopera)
    let budgetPrev=importoContrattuale - (importoContrattuale - (data.costo_ordini + data.costo_manodopera))

        if (data.incarichi.length > 0) {
            importoContrattuale = 0;
            let materialCost = 0;
            markupPrev = 0;
            budgetPrev = 0;

            let costoOrdiniPreventivato = 0;
            let costoManodoperaPreventivato = 0;
            data.fc_ordini = [];
            data.incarichi.map((incarico, index) => {
                data.fattures=[]
                incarico.fattures.map((fatt) => {
                    data.fattures.push(fatt)
                })
                importoContrattuale += incarico.preventivo;
                materialCost += materialCostCommessa(incarico)
                costoOrdiniPreventivato += incarico.costo_ordini;
                costoManodoperaPreventivato += incarico.costo_manodopera

                data.fc_ordini=data.fc_ordini.concat(incarico.fc_ordini);
            })

            budgetPrev = importoContrattuale - (importoContrattuale - (costoOrdiniPreventivato + costoManodoperaPreventivato))
            markupPrev = importoContrattuale - (costoOrdiniPreventivato + costoManodoperaPreventivato);
        }


        let labels = getAllMonthsinYear(this.state.selectedYear + "-01-01")
        let dates = getAllMonthsinYear(this.state.selectedYear + "-01-01", "date")

        if (labels.length <= 1) {
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            labels = getAllMonths(d)
            dates = getAllMonths(d, "date")
        }

        let dataset = []
        if (this.state.graphSelected == "GIORNI") {
            let totalDuration = this.totalDuration();

            let workedDays = [];
            let totalDays = [];
            let unworkedDays = [];
            dates.forEach((el) => {
                let temp = getWorkedDaysNumber(this.state.worker, el, getLastDateOfMonth(el));
                if (workedDays.length > 0) {
                    temp += workedDays[workedDays.length - 1];
                } else {
                    temp += getWorkedDaysNumber(this.state.worker, "1990-01-01", getLastDateOfMonthBefore(el));
                }

                if (isAccordoQuadro(this.state.data[this.state.selected])) {
                    temp = getAQPassedDays(this.state.data[this.state.selected]);
                }
                if (temp >= totalDuration) {
                    temp = totalDuration;
                }

                workedDays.push(temp);
                totalDays.push(totalDuration);
                unworkedDays.push(totalDuration - temp)
            });

            dataset.push({
                label: "Giorni Totali",
                color: "info",
                data: totalDays,
            })
            dataset.push({
                label: isAccordoQuadro(this.state.data[this.state.selected])?"Giorni Passati":"Giorni Lavorati",
                color: "success",
                data: workedDays,
            })
            dataset.push({
                label: "Giorni Mancanti",
                color: "warning",
                data: unworkedDays,
            })
        }


        if (this.state.graphSelected == "COSTI") {
            let materialCost = [];
            let workerCost = [];
            let totalCost = [];

                dates.forEach((el) => {
                    let temp = materialCostCommessa(data, el, getLastDateOfMonth(el));
                    if (materialCost.length > 0) {
                        temp += materialCost[materialCost.length - 1];
                    } else {
                        temp += materialCostCommessa(data, "1900-01-01", getLastDateOfMonthBefore(el));
                    }

                    let tempWork = laborCostCommessa(this.state.worker, el, getLastDateOfMonth(el), this.state.data[this.state.selected]);
                    if (workerCost.length > 0) {
                        tempWork += workerCost[workerCost.length - 1];
                    } else {
                        tempWork += laborCostCommessa(this.state.worker, "1900-01-01", getLastDateOfMonthBefore(el), this.state.data[this.state.selected]);
                    }

                    materialCost.push(temp);
                    workerCost.push(tempWork);
                    totalCost.push(materialCost[materialCost.length - 1] + workerCost[workerCost.length - 1])
                });
            

            dataset.push({
                label: "COSTO ORDINI AD OGGI",
                color: "info",
                data: materialCost,
            })
            dataset.push({
                label: "COSTO MANODOPERA AD OGGI",
                color: "success",
                data: workerCost,
            })
            dataset.push({
                label: "COSTO TOTALE AD OGGI",
                color: "warning",
                data: totalCost,
            })
        }
        
        if (this.state.graphSelected == "MARKUP") {
            let materialCost = [];
            let workerCost = [];

            dates.forEach((el) => {
                let temp = materialCostCommessa(data, el, getLastDateOfMonth(el));
                if (materialCost.length > 0) {
                    temp += materialCost[materialCost.length - 1];
                } else {
                    temp += materialCostCommessa(data, "1900-01-01", getLastDateOfMonthBefore(el));
                }

                let tempWork = laborCostCommessa(this.state.worker, el, getLastDateOfMonth(el), this.state.data[this.state.selected]);
                if (workerCost.length > 0) {
                    tempWork += workerCost[workerCost.length - 1];
                } else {
                    tempWork += laborCostCommessa(this.state.worker, "1900-01-01", getLastDateOfMonthBefore(el), this.state.data[this.state.selected]);
                }

                materialCost.push(temp);
                workerCost.push(tempWork);
            });


            let markup = [];
            let markupP=[];
            dates.forEach((el, index) => {
                let temp = calculateMarkupReal(data, materialCost[index], workerCost[index], el, getLastDateOfMonth(el))
                if (temp.length > 0) {
                    temp += temp[temp.length - 1];
                } else {
                    temp += calculateMarkupReal(data, 0, 0, "1900-01-01", getLastDateOfMonthBefore(el))
                }

                markup.push(temp);
                markupP.push(markupPrev)
            });

            dataset.push({
                label: "MARK UP REALE",
                color: "info",
                data: markup,
            })
            dataset.push({
                label: "MARK UP PREVENTIVATO",
                color: "success",
                data: markupP,
            })
        }

        if (this.state.graphSelected == "BUDGET") {
            let materialCost = [];
            let workerCost = [];

            dates.forEach((el) => {
                let temp = materialCostCommessa(data, el, getLastDateOfMonth(el));
                if (materialCost.length > 0) {
                    temp += materialCost[materialCost.length - 1];
                } else {
                    temp += materialCostCommessa(data, "1900-01-01", getLastDateOfMonthBefore(el));
                }

                let tempWork = laborCostCommessa(this.state.worker, el, getLastDateOfMonth(el), this.state.data[this.state.selected]);
                if (workerCost.length > 0) {
                    tempWork += workerCost[workerCost.length - 1];
                } else {
                    tempWork += laborCostCommessa(this.state.worker, "1900-01-01", getLastDateOfMonthBefore(el), this.state.data[this.state.selected]);
                }

                materialCost.push(temp);
                workerCost.push(tempWork);
            });


            let markup = [];
            let budget = [];
            let budgetP = [];

            dates.forEach((el, index) => {
                let temp = calculateMarkupReal(data, materialCost[index], workerCost[index], el, getLastDateOfMonth(el))
                if (temp.length > 0) {
                    temp += temp[temp.length - 1];
                } else {
                    temp += calculateMarkupReal(data, 0, 0, "1900-01-01", getLastDateOfMonthBefore(el))
                }

                markup.push(temp);

                temp = calculateBudgetReal(data, markup[index], el, getLastDateOfMonth(el))
                if (temp.length > 0) {
                    temp += temp[temp.length - 1];
                } else {
                    temp += calculateBudgetReal(data, 0, "1900-01-01", getLastDateOfMonthBefore(el))
                }

                budget.push(temp);
                budgetP.push(budgetPrev)
            });

            dataset.push({
                label: "BUDGET REALE",
                color: "info",
                data: budget,
            })
            dataset.push({
                label: "BUDGET PREVENTIVATO",
                color: "success",
                data: budgetP,
            })
        }

        let workedDays = getWorkedDaysNumber(this.state.worker);
        if (isAccordoQuadro(data)) {
            workedDays = getAQPassedDays(data);
        }
        let endDate = calculateFinalDate(data.data_inizio, this.totalDuration(), (data.days_type == "Consecutivi" ? false : true))
        let dataStimata = calculateFinalDate(new Date(), this.totalDuration() - workedDays, (data.days_type == "Consecutivi" ? false : true))

        let start = new Date(data.data_inizio);
        let end = new Date(toDashDate(endDate))
        let stimata = new Date(toDashDate(dataStimata));

        return (<>
            <MDBox display="flex">
                <MDBox width="4rem"
                    height="4rem"
                    bgColor={"info"}
                    variant="gradient"
                    coloredShadow={"info"}
                    borderRadius="xl"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    color="white"
                    mr={2}
                    ml={2}><Icon>{icon}</Icon>
                </MDBox>
                <MDBox alignItems="center" mr={2}>
                    <MDTypography variant="h6">{data.nome}</MDTypography>
                </MDBox>
                <Grid container>
                    <Grid item p={1}>
                        <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption">Giorni</MDTypography>
                            <MDButton onClick={() => this.setState({ graphSelected: "GIORNI" })} variant="gradient" color={(this.state.graphSelected == "GIORNI") ? "info" : "secondary"} iconOnly><Icon>calendar_month</Icon></MDButton>
                        </MDBox>
                    </Grid>
                    <Grid item p={1}>
                        <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption">Costi</MDTypography>
                            <MDButton onClick={() => this.setState({ graphSelected: "COSTI" })} variant="gradient" color={(this.state.graphSelected == "COSTI") ? "info" : "secondary"} iconOnly><Icon>payments</Icon></MDButton>
                        </MDBox>
                    </Grid>
                    <Grid item p={1}>
                        <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption">Mark up</MDTypography>
                            <MDButton onClick={() => this.setState({ graphSelected: "MARKUP" })} variant="gradient" color={(this.state.graphSelected == "MARKUP") ? "info" : "secondary"} iconOnly><Icon>trending_up</Icon></MDButton>
                        </MDBox>
                    </Grid>
                    <Grid item p={1}>
                        <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption">Budget di commessa</MDTypography>
                            <MDButton onClick={() => this.setState({ graphSelected: "BUDGET" })} variant="gradient" color={(this.state.graphSelected == "BUDGET") ? "info" : "secondary"} iconOnly><Icon>savings</Icon></MDButton>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <GradientLineChart
                chart={{
                    labels: labels,
                    datasets: dataset,
                }}
                annotation={{
                    Inizio: {
                        display: start.getFullYear() == this.state.selectedYear ? true : false,
                        type: 'line',
                        xMin: shortMonthName(start.getMonth()),
                        xMax: shortMonthName(start.getMonth()),
                        borderColor: 'rgb(255, 99, 132)',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            content: "Inizio: "+toEuropeanDate(start),
                            backgroundColor: "rgba(255, 26, 104, 0.8)",
                            color: "black",
                            rotation: -90,
                        },
                    },
                    Fine: {
                        display: end.getFullYear() == this.state.selectedYear ? true : false,
                        type: 'line',
                        xMin: shortMonthName(end.getMonth()),
                        xMax: shortMonthName(end.getMonth()),
                        borderColor: 'rgb(255, 99, 132)',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            content: "Fine: " + toEuropeanDate(end),
                            backgroundColor: "rgba(255, 26, 104, 0.8)",
                            color: "black",
                            rotation: -90,
                        },
                    },
                    Stimata: {
                        display: stimata.getFullYear() == this.state.selectedYear && !isAccordoQuadro(data) ? true : false,
                        type: 'line',
                        xMin: shortMonthName(stimata.getMonth()),
                        xMax: shortMonthName(stimata.getMonth()),
                        borderColor: 'rgb(255, 99, 132)',
                        borderWidth: 2,
                        label: {
                            enabled: true,
                            content: "Stimata: " + toEuropeanDate(stimata),
                            backgroundColor: "rgba(255, 26, 104, 0.8)",
                            color: "black",
                            rotation: -90,
                        },
                    },
                }}
                priceMode={(this.state.graphSelected == "GIORNI") ? false : true}
            />
            <Grid mb={3} container justifyContent={"space-around"}>
                <Grid item>
                    <MDButton variant="text" color="dark" onClick={() => this.changeYear(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                </Grid>
                <Grid item>{this.state.selectedYear}</Grid>
                <Grid item>
                    <MDButton variant="text" color="dark" onClick={() => this.changeYear(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                </Grid>
            </Grid>



        </>

        )
    }
   
    render() {
        if (this.state.selected == -1 && this.state.data.length > 0) {
            this.setSelected(0)
        }
        return (
            <Grid container sx={{height:"100%"}}>
                <MDTypography variant={"h5"} textTransform={"uppercase"} mb={2} >Commesse</MDTypography>
                <Grid container sx={{ height: "100%" }} pb={4}>
                    <Grid item sm={2} sx={{ borderRight: "1px solid black", height:"100%", overflow:"auto" }}>
                        {this.state.data.map((el, index) => {
                            return this.renderButton(el.nome, index);
                        })}
                    </Grid>


                    {(this.state.workerLoaded && this.state.salLoaded) ?
                        <Grid item sm={10}>
                            <Grid container>
                                <Grid item sm={4}>
                                    {(this.state.selected != -1) ? this.renderDati() : null}
                                </Grid>
                                <Grid item sm={8}>
                                    {(this.state.selected != -1) ? this.renderGraphic() : null}
                                </Grid>
                            </Grid>
                        </Grid>
                        : null
                    }
                </Grid>
            </Grid>
        )
    }
    
}

export default CommesseAndamento;


CommesseAndamento.defaultProps = {

}
